<template>
    <div class="pcoded-main-container error-page-custom " style="">
        <div class="page-body" style="overflow: hidden;">
            <div class="not-found-go-back">
                <img :src="require('~public_image/logo_background/Logo-header.png')"/>
            </div>
            <div class="not-found-label">
                <v-btn color="white"  text @click="_goBack()"><v-icon>mdi-arrow-left-bold-circle-outline</v-icon></v-btn>
                Page not found
            </div>
  
        </div>
    </div>
</template>

<script>

export default {

    metaInfo: {
        titleTemplate: `%s | Page Not Found`
    },
    methods:{
        _goBack(){
            this.$router.go(-1)
        }
    }
};

</script>
<style>
.not-found-go-back {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    border-radius: 8px;
}
.not-found-go-back img{
    width:320px;
    height:auto;
}
.not-found-label {
    min-width:320px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 20px 40px 20px 0;
    background-color: #0500006e;
    border: 1px solid #ccc;
    color:white!important;
    border-radius: 8px;
    text-transform: uppercase;
    font-size:1.35em;
    
}
.error-page-custom{
    position:relative; min-height: 100vh!important; margin-top:0!important; background-image: url(../../../../public/images/a_page_access_global/SBC2888\ Background.jpg);
}
</style>